(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    

	var reviews = jQuery('.footer-review');
	console.log("reviews", reviews);

	var random = Math.floor(Math.random()*reviews.length);
	reviews.eq(random).show();
	console.log("random", random);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-highlight-collection"] && !window.DesignMode) return;
  try {
    
$('.product-highlight-link').click(function(e) {
  if(e) {
    e.preventDefault();
  }
  $('.product-highlight-link').removeClass('active');
  $(this).addClass('active');
  $('.productHighlightContent').removeClass('visible');
  $($(this).attr('href')).addClass('visible');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscribe-now"] && !window.DesignMode) return;
  try {
    
var form=document.querySelector('#mc-embedded-subscribe-form')
function subscribeHandler(event){
    event.preventDefault()
    event.stopImmediatePropagation()
    // console.log('subscribed')
    document.querySelector('input#signupFormToggler').checked = false
    localStorage.setItem('mailChimpSubscribed', true);
	form.submit()
  }
function subscribeHide(e){
    e.stopImmediatePropagation()
	if (e.target.className=='subscribe--overlay'){
	var checkbox=document.querySelector('input#signupFormToggler')
    checkbox.checked = false
	}
}
function subscribeKeepItClosed(){
    sessionStorage.setItem('mailChimpClosed', true);
}
function subscribeShow(){
	// console.log('2nd stage')
	var checkbox=document.querySelector('input#signupFormToggler')
	// console.log('2.1 stage')
	var notSubscribed=localStorage.getItem('mailChimpSubscribed')==='true'?false:true
	// console.log('2.2 stage')
	var notClosed=sessionStorage.getItem('mailChimpClosed')==='true'?false:true
	// console.log('2.3 stage')
	if (checkbox && notSubscribed && notClosed){
	// console.log('3rd stage')
      checkbox.checked =  notSubscribed
      document.querySelector('input#mc-embedded-subscribe').addEventListener('click',subscribeHandler,false)
      form.addEventListener('submit',subscribeHandler,false)
	  document.querySelector('div.subscribe--overlay').addEventListener('click',subscribeHide,false)
	  checkbox.addEventListener('change',subscribeKeepItClosed,false)
    } else {
	console.warn("checkbox: "+checkbox+ " notSubscribed: "+notSubscribed + " notClosed: "+notClosed)
	}
}


if (!subscribeTypeButton){
window.addEventListener("load", function(event) {
	if (subscribeDelayTime){
	window.setTimeout(subscribeShow,subscribeDelayTime)
	}
})
}





  } catch(e) { console.error(e); }
})();
})();
